import { render, staticRenderFns } from "./menusList.vue?vue&type=template&id=4c00e416&scoped=true&"
import script from "./menusList.vue?vue&type=script&lang=js&"
export * from "./menusList.vue?vue&type=script&lang=js&"
import style0 from "./menusList.vue?vue&type=style&index=0&id=4c00e416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c00e416",
  null
  
)

export default component.exports